module.exports = __webpack_public_path__ + "static/media/chevron-right.02667795.svg";